import loadable from "@loadable/component"

import React from "react"

const ArticleBodySection = loadable(
  () => import("../components/StoryBlok/V2/Layout/ArticleBodySection")
)
const ArticleSection = loadable(
  () => import("../components/StoryBlok/V2/Layout/ArticleSection")
)

// Hero components start
const ContentHalfHero = loadable(
  () => import("../components/StoryBlok/V2/Hero/Content/HalfHero")
)

const ContentIndustryHero = loadable(
  () => import("../components/StoryBlok/V2/Hero/Content/IndustryHero")
)

const ContentCentreHero = loadable(
  () => import("../components/StoryBlok/V2/Hero/Content/CentreHero")
)

const ContentFloodHero = loadable(
  () => import("../components/StoryBlok/V2/Hero/Content/FloodHero")
)

const ProductHalfHero = loadable(
  () => import("../components/StoryBlok/V2/Hero/Product/HalfHero")
)

const OldArticleHero = loadable(
  () => import("../components/StoryBlok/V2/Hero/OldArticleHero")
)

const ProductCatalogueHero = loadable(
  () => import("../components/StoryBlok/V2/Hero/Product/CatalogueHero")
)

const ProductBorderedHero = loadable(
  () => import("../components/StoryBlok/V2/Hero/Product/BorderedHero")
)

const ContentBorderedHero = loadable(
  () => import("../components/StoryBlok/V2/Hero/Content/BorderedHero")
)

// Hero components end

// Layout components start
const GridSection = loadable(
  () => import("../components/StoryBlok/V2/Layout/GridSection")
)
const MasonrySection = loadable(
  () => import("../components/StoryBlok/V2/Layout/MasonrySection")
)
const SliderSection = loadable(
  () => import("../components/StoryBlok/V2/Layout/SliderSection")
)
const ComparisonTableSection = loadable(
  () => import("../components/StoryBlok/V2/Layout/ComparisonTableSection")
)
const SpacerSection = loadable(
  () => import("../components/StoryBlok/V2/Layout/SpacerSection")
)
const SocialProofing = loadable(
  () => import("../components/StoryBlok/V2/Section/SocialProofing")
)
const PlanComparisonTable = loadable(
  () => import("../components/StoryBlok/V2/Section/PlanComparisonTable")
)

const ProductInfoSection = loadable(
  () => import("../components/StoryBlok/V2/Section/ProductInfo"),
  {
    fallback: <div className="col-span-full min-h-screen" />,
  }
)

// Layout components end

// Social Proofing components start

const TestimonialCard = loadable(
  () => import("../components/StoryBlok/V2/Card/TestimonialCard")
)

// Social Proofing components end

// Banner start
const PaymentLogoBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/PaymentLogoBanner")
)
const CentreCTABanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/CentreCTABanner")
)
const ArticleBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/ArticleBanner")
)
const ArticleIconList = loadable(
  () => import("../components/StoryBlok/V2/Layout/ArticleIconList")
)

const Toast = loadable(() => import("../components/StoryBlok/V2/Toast"))
const PromoCTACounterBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/PromoCTACounterBanner")
)
const RatingBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/RatingBanner")
)
const TabSelectorBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/TabSelectorBanner")
)
const SocialProofBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/SocialProofBanner")
)
const ScrollingLogoBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/ScrollingLogoBanner")
)
const InteractiveImage = loadable(
  () => import("../components/StoryBlok/V2/Banner/InteractiveImage")
)

const NavigationBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/NavigationBanner")
)

const HeaderCTABanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/HeaderCTABanner")
)
const HeaderBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/HeaderBanner")
)
const FeatureBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/FeatureBanner")
)
const VideoBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/VideoBanner")
)
const RightCTABanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/RightCTABanner")
)
// Banner end

// Card/Content components start
const BenefitBulletCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/Benefit/Bullet")
)
const BenefitCopyCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/Benefit/Copy")
)
const BulletPointBulletItemsCard = loadable(
  () =>
    import("../components/StoryBlok/V2/Card/Content/BulletPoints/BulletItems")
)
const BulletPointIconInfoCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/BulletPoints/IconInfo")
)
const BulletPointListItemsCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/BulletPoints/ListItems")
)
const DataCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/Data")
)
const InfoCTACard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/Info/CTA")
)
const InfoRatingCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/Info/Rating")
)
const InfoTextCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/Info/Text")
)
const BlogCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/BlogCard")
)
const CalloutCard = loadable(
  () => import("../components/StoryBlok/V2/Card/CalloutCard")
)
// Card/Content components end

// Card/Package components start

const PackageBulletCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Package/BulletCard")
)
const PackageDataCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Package/DataCard")
)
const PackageProPlanCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Package/ProPlanCard")
)
const CompareCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Package/CompareCard")
)
const PlanCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Package/PlanCard")
)
const TurnoverSelectorCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Package/TurnoverSelectorCard")
)
const MachineBenefitCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Package/MachineBenefitCard")
)
const MachineBundleCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Package/MachineBundleCard")
)
// Card/Package components end

// Card/Eco-System components start
const EcoSystemContentCard = loadable(
  () => import("../components/StoryBlok/V2/Card/EcoSystem/Content")
)
const EcoSystemBenefitsCard = loadable(
  () => import("../components/StoryBlok/V2/Card/EcoSystem/Benefits")
)
const EcoSystemIntroCard = loadable(
  () => import("../components/StoryBlok/V2/Card/EcoSystem/Intro")
)
const EcoSystemIntroCardExperiment = loadable(
  () => import("../experiments/EcoSystemIntroCard/Storyblok")
)
const EcoSystemListCard = loadable(
  () => import("../components/StoryBlok/V2/Card/EcoSystem/List")
)
// Card/Eco-System components end

// Card/Policy components start
const PolicyCard = loadable(
  () => import("../components/StoryBlok/V2/Card/PolicyCard")
)
// Card/Policy components end

// Card/Plans components start
const PlansCalculatorRecommendedCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Plans/CalculatorRecommended")
)
const RecommendedPlanConfigCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Plans/RecommendedPlanConfig")
)
const PlanInfoCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Plans/Info")
)
const PlanPricingCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Plans/Pricing")
)
// Card/Plans components end

const BentoCard = loadable(
  () => import("../components/StoryBlok/V2/Card/BentoCard")
)

// Section components start
const FaqSection = loadable(
  () => import("../components/StoryBlok/V2/Section/Faq")
)
const ModalSection = loadable(
  () => import("../components/StoryBlok/V2/Section/ModalSection")
)
const ContentBanner = loadable(
  () => import("../components/StoryBlok/V2/Section/Banner/Content")
)
const RichMediaBanner = loadable(
  () => import("../components/StoryBlok/V2/Section/Banner/RichMedia")
)

// Section components end

// Form components start
const RentalReaderForm = loadable(
  () => import("../components/StoryBlok/V2/Form/RentalReaderForm")
)
//  Form components end

// Card/Product components start
const ProductCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Product/index")
)
// Card/Product components end

// Card/RichMedia components start
const RichMediaHightlightCard = loadable(
  () => import("../components/StoryBlok/V2/Card/RichMedia/Highlight")
)
const RichMediaInfoTabCard = loadable(
  () => import("../components/StoryBlok/V2/Card/RichMedia/InfoTab")
)
const RichMediaUIOverlayCard = loadable(
  () => import("../components/StoryBlok/V2/Card/RichMedia/UIOverlay")
)
// Card/RichMedia components end

// Card Components Start
const CTACard = loadable(
  () => import("../components/StoryBlok/V2/Card/CTACard")
)
// Card Components End

const QuestionAnswerBlock = loadable(
  () => import("../components/StoryBlok/V2/Section/QuestionAnswer")
)

// V2/Legacy components start
const RichTextBlock = loadable(
  () => import("../components/StoryBlok/RichTextBlock")
)
const ModalContainer = loadable(
  () => import("../components/StoryBlok/V2/Legacy/ModalContainer")
)
const EmbedCode = loadable(
  () => import("../components/StoryBlok/V2/Legacy/EmbedCode")
)

const ImageGenerator = loadable(
  () => import("../components/StoryBlok/V2/Legacy/ImageGenerator")
)
// V2/Legacy components end

// V2/Lab components start
const InteractiveParagraph = loadable(
  () => import("../components/StoryBlok/V2/Lab/InteractiveParagraph")
)
const BenefitDriver = loadable(
  () => import("../components/StoryBlok/V2/Lab/BenefitDriver")
)
const CategorySlider = loadable(
  () => import("../components/StoryBlok/V2/Lab/CategorySlider")
)
const CategorySlide = loadable(
  () => import("../components/StoryBlok/V2/Lab/CategorySlide")
)
const CartOverview = loadable(
  () => import("../components/StoryBlok/V2/Lab/CartOverview")
)
// V2/Lab components end

const TextItem = loadable(
  () => import("../components/StoryBlok/V2/Shop/TextItem")
)

const SpecificationTable = loadable(
  () => import("../components/StoryBlok/V2/Shop/SpecificationTable")
)

const IconInfo = loadable(
  () => import("../components/StoryBlok/V2/Shop/IconItem")
)

const ImageItem = loadable(
  () => import("../components/StoryBlok/V2/Shop/ImageItem")
)

const ArticleImage = loadable(
  () => import("../components/StoryBlok/V2/ArticleImage")
)

const ArticleVideo = loadable(
  () => import("../components/StoryBlok/V2/ArticleVideo")
)

const ArticleFilterSection = loadable(
  () => import("../components/StoryBlok/V2/Section/ArticleFilterSection")
)

const ArticleParagraph = loadable(
  () => import("../components/StoryBlok/V2/Lab/ArticleParagraph")
)

const ArticleTable = loadable(
  () => import("../components/StoryBlok/V2/Lab/ArticleTable")
)

const StoryblokAccordion = loadable(
  () => import("../components/StoryBlok/Accordion")
)

const SolutionOfferCard = loadable(
  () => import("../components/StoryBlok/Experiments/SolutionOfferCard")
)

const TestimonialSwiper = loadable(
  () => import("../components/StoryBlok/V2/Section/TestimonialSwiper")
)

const GroupOfIntroInfoCards = loadable(
  () => import("../components/StoryBlok/Experiments/GroupOfIntroInfoCards")
)

const CaseStudySectionItem = loadable(
  () => import("../experiments/CaseStudySectionItem/Storyblok")
)

const CaseStudyCard = loadable(
  () => import("../experiments/CaseStudyCard/Storyblok")
)

const CaseStudySection = loadable(
  () => import("../experiments/CaseStudySection/Storyblok")
)

const QuoteTextCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Content/QuoteTextCard")
)

const TestimonialHeroExperiment = loadable(
  () => import("../experiments/TestimonialHero/Storyblok")
)

const PackageDetailsCard = loadable(
  () => import("../components/StoryBlok/V2/Card/Package/PackageDetailsCard")
)

const AccordionSlider = loadable(
  () => import("../components/StoryBlok/Lab/AccordionSlider")
)

const UnpackedCardExperiment = loadable(
  () => import("../experiments/UnpackedCard/Storyblok")
)

const CommunityFormExperiment = loadable(
  () => import("../experiments/CommunityForm/Storyblok")
)

const ProductReview = loadable(
  () => import("../components/StoryBlok/Experiments/ProductReview")
)

const ProductThirdsHeroExperiment = loadable(
  () => import("../experiments/ThirdsHero/Product/Storyblok")
)

const ContentThirdsHeroExperiment = loadable(
  () => import("../experiments/ThirdsHero/Content/Storyblok")
)

const ContentCard = loadable(
  () => import("../experiments/ContentProductCard/Storyblok")
)

const SolutionFinder = loadable(
  () => import("../experiments/ProductJourneys/SolutionFinder/Storyblok")
)
const SolutionOffer = loadable(
  () => import("../experiments/ProductJourneys/SolutionOffer/Storyblok")
)

const RichTextParagraph = loadable(
  () => import("../experiments/RichTextParagraph/")
)

const CartBuilder = loadable(
  () => import("../experiments/ProductJourneys/CartBuilder/Storyblok")
)
const HomePageHero = loadable(
  () => import("../experiments/HomePageHero/Storyblok")
)

const ProductCatalogue = loadable(
  () => import("../components/StoryBlok/V2/Layout/ProductCatalogueSection")
)
const ProductShowCase = loadable(
  () => import("../components/StoryBlok/V2/Layout/ProductShowCase")
)
const IntroCard = loadable(
  () => import("../components/StoryBlok/V2/Card/IntroCard")
)

const PlansBanner = loadable(
  () => import("../components/StoryBlok/V2/Banner/PlansBanner")
)

const PlanGridSection = loadable(
  () => import("../components/StoryBlok/V2/Layout/PlanGridSection")
)
const JobListingSection = loadable(
  () => import("../components/StoryBlok/V2/JobListings/Storyblok")
)
const RegisterReaderForm = loadable(
  () => import("../components/StoryBlok/V2/Form/RegisterReaderForm")
)
const SetupShowcase = loadable(
  () => import("../components/StoryBlok/V2/Banner/SetupShowcase")
)

export default {
  contentHalfHero: ContentHalfHero,
  contentCentreHero: ContentCentreHero,
  contentFloodHero: ContentFloodHero,
  contentIndustryHero: ContentIndustryHero,
  productHalfHero: ProductHalfHero,
  articleHero: OldArticleHero,
  productBorderedHero: ProductBorderedHero,
  productCatalogueHero: ProductCatalogueHero,
  gridSection: GridSection,
  masonrySection: MasonrySection,
  sliderSection: SliderSection,
  comparisonTableSection: ComparisonTableSection,
  planComparisonTable: PlanComparisonTable,
  spacerSection: SpacerSection,
  productInfoSection: ProductInfoSection,
  socialProofing: SocialProofing,
  testimonialCard: TestimonialCard,
  benefitCopyCard: BenefitCopyCard,
  benefitBulletCard: BenefitBulletCard,
  dataCard: DataCard,
  infoCTACard: InfoCTACard,
  infoRatingCard: InfoRatingCard,
  infoTextCard: InfoTextCard,
  blogCard: BlogCard,
  bulletPointBulletItemsCard: BulletPointBulletItemsCard,
  bulletPointListItemsCard: BulletPointListItemsCard,
  bulletPointIconInfoCard: BulletPointIconInfoCard,
  ecoSystemContentCard: EcoSystemContentCard,
  ecoSystemBenefitsCard: EcoSystemBenefitsCard,
  ecoSystemIntroCard: EcoSystemIntroCard,
  ecoSystemIntroCardExperiment: EcoSystemIntroCardExperiment,
  ecoSystemListCard: EcoSystemListCard,
  policyCard: PolicyCard,
  faqSection: FaqSection,
  modalSection: ModalSection,
  richMediaHighlightCard: RichMediaHightlightCard,
  richMediaInfoTabCard: RichMediaInfoTabCard,
  richMediaUIOverlayCard: RichMediaUIOverlayCard,
  cTACard: CTACard,
  paymentLogoBanner: PaymentLogoBanner,
  centreCTABanner: CentreCTABanner,
  toast: Toast,
  promoCTACounterBanner: PromoCTACounterBanner,
  ratingBanner: RatingBanner,
  tabSelectorBanner: TabSelectorBanner,
  contentBanner: ContentBanner,
  socialProofBanner: SocialProofBanner,
  scrollingLogoBanner: ScrollingLogoBanner,
  navigationBanner: NavigationBanner,
  ctaCard: null as any,
  packageBulletCard: PackageBulletCard,
  packageDataCard: PackageDataCard,
  packageProPlanCard: PackageProPlanCard,
  packageDetailsCard: PackageDetailsCard,
  compareCard: CompareCard,
  planCard: PlanCard,
  packageTurnoverSelectorCard: TurnoverSelectorCard,
  packageMachineBenefitCard: MachineBenefitCard,
  packageMachineBundleCard: MachineBundleCard,
  richMediaBanner: RichMediaBanner,

  headerCTABanner: HeaderCTABanner,
  headerBanner: HeaderBanner,
  featureBanner: FeatureBanner,
  videoBanner: VideoBanner,
  question_answer: QuestionAnswerBlock,
  richtext_block: RichTextBlock, // TODO: Move out of storyblok V2/Legacy group when reworked
  videoModalContainer: ModalContainer, // TODO: Move out of storyblok V2/Legacy group when reworked
  embed_code: EmbedCode, // TODO: Move out of storyblok V2/Legacy group when reworked

  plansCalculatorRecommendedCard: PlansCalculatorRecommendedCard,
  recommendedPlanConfigCard: RecommendedPlanConfigCard,
  planInfoCard: PlanInfoCard,
  planPricingCard: PlanPricingCard,
  image_generator: ImageGenerator,
  interactiveParagraph: InteractiveParagraph,
  interactiveImage: InteractiveImage,
  benefitDriver: BenefitDriver,
  categorySlider: CategorySlider,
  categorySlide: CategorySlide,
  cartOverview: CartOverview,
  solutionOffer: SolutionOffer,
  textItem: TextItem,
  specificationTable: SpecificationTable,
  iconInfo: IconInfo,
  imageItem: ImageItem,
  articleImage: ArticleImage,
  articleVideo: ArticleVideo,
  articleFilterSection: ArticleFilterSection,
  rentalReaderForm: RentalReaderForm,
  accordion: StoryblokAccordion,
  articleSection: ArticleSection,
  calloutCard: CalloutCard,
  bentoCard: BentoCard,
  productCard: ProductCard,
  testimonialSwiper: TestimonialSwiper,
  solutionOfferCard: SolutionOfferCard,
  introInfoCard: GroupOfIntroInfoCards,
  testimonialHeroExperiment: TestimonialHeroExperiment,
  quoteTextCard: QuoteTextCard,
  socialProofingV2Experiment: null as any,
  caseStudyCardExperiment: CaseStudyCard,
  caseStudySectionExperiment: CaseStudySectionItem,
  caseStudyLayoutExperiment: CaseStudySection,
  accordionSlider: AccordionSlider,
  googleFormExperiment: null as any,
  contentBorderedHero: ContentBorderedHero,
  unpackedCard: UnpackedCardExperiment,
  communityForm: CommunityFormExperiment,
  productReview: ProductReview,
  productThirdsHero: ProductThirdsHeroExperiment,
  contentThirdsHero: ContentThirdsHeroExperiment,
  contentCard: ContentCard,
  introductionCard: IntroCard,
  solutionFinder: SolutionFinder,
  richTextParagraph: RichTextParagraph,
  cartBuilder: CartBuilder,
  productCatalogue: ProductCatalogue,
  productShowCase: ProductShowCase,
  homePageHero: HomePageHero,
  plansBanner: PlansBanner,
  planGridSection: PlanGridSection,
  jobListSection: JobListingSection,
  rightCTABanner: RightCTABanner,
  registerReaderForm: RegisterReaderForm,
  overviewSection: null as any,
  productFinderHint: null as any,
  // article page
  articleTable: ArticleTable,
  articleParagraph: ArticleParagraph,
  articleBodySection: ArticleBodySection,
  articleBanner: ArticleBanner,
  articleIconList: ArticleIconList,
  setupShowcase: SetupShowcase,
}
